<template>
	<b-container id="main-content" fluid>
		<b-row class="mb-3">
			<b-col>
				<b-button variant="primary" @click="create_app()" v-focus
					>New Application</b-button
				>
			</b-col>
			<b-col>
				<b-btn class="float-right" variant="primary" @click="logout"
					>Logout</b-btn
				>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<b-card-group deck class="mb-3">
					<b-card
						v-for="app in applications"
						:key="app.id"
						class="mb-3"
						style="min-width: 15rem; max-width: 30rem;"
						header-bg-variant="light"
					>
						<div slot="header" class="text-dark">
							<div class="bigger">
								<b>Application {{ app.id }}</b>
							</div>
							<b-btn
								v-if="!app.submitted"
								variant="primary"
								size="sm"
								class="float-right"
								title="Edit Application Type"
								v-b-popover.hover="
									'Change applicant type or campuses applying to'
								"
								@click="edit_app(app.id)"
							>
								Edit
							</b-btn>
						</div>
						<b-card-body>
							<p class="card-text">
								Application has {{ app.submitted ? "" : "not " }}been submitted
							</p>
							<p class="card-text">
								Applicant Type:<br />
								{{
									app.applicantType === "traditional"
										? "Traditional"
										: "Non-Traditional"
								}}
								{{ app.studentType === "transfer" ? "Transfer" : "First Year" }}
							</p>
							<p class="card-text">
								Application Started On:
								{{ new Date(app.created).toLocaleString() }}
							</p>
						</b-card-body>
						<div class="bigger">Campuses applying to:</div>
						<b-list-group flush>
							<b-list-group-item
								v-for="campus in app.campuses"
								:key="campus.order"
								>{{ campus }}
							</b-list-group-item>
						</b-list-group>
						<b-card-body>
							<b-button
								v-if="!app.submitted"
								@click.capture="go_to_app(app.id)"
								variant="primary"
								>Continue Application
							</b-button>
						</b-card-body>
					</b-card>
				</b-card-group>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
	computed: {
		...mapGetters(["applications", "campuses", "userType"])
	},
	methods: {
		...mapActions(["get_applications"]),
		...mapMutations(["set_active_application"]),
		human_traditional(traditional) {
			return traditional === "nontrad" ? "Non-Traditional" : "Traditional";
		},
		human_year(year) {
			return year === "transfer" ? "Transfer" : "First Year";
		},
		campus_name(campusCode) {
			let campusName = null;
			this.campuses.some(function(campus) {
				if (campus === campusCode) {
					campusName = campus.name;
					return true;
				}
			});
			return campusName;
		},
		go_to_app(app_id) {
			this.set_active_application(app_id);
			this.$router.push("/app");
		},
		edit_app(app_id) {
			this.set_active_application(app_id);
			this.$router.push("/edit-app");
		},
		logout() {
			this.$store.dispatch("logout_user");
		},
		create_app() {
			this.$router.push("/new-app");
		}
	},
	mounted() {
		this.get_applications();
	},
	watch: {
		userType(value) {
			if (value !== "authed") {
				this.$router.push("/");
			}
		}
	}
};
</script>

<style scoped>
div.bigger {
	font-size: larger;
}
</style>
